<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="employeesLimit"
				textCreate="Add employee"
				:flag="flag"
				page-title="Employees"
				:headers="headers"
				:settings="getSettings"
				:filtersList="employeesFilters"
				:list="employeesList"
				:defaultOrder="employeesOrder"
				:defaultSort="employeesSort"
				:defaultFilter="defaultFilter"

				:totals="employeesTotals"
				:total-pages="employeesTotal"
				:limit-pages="employeesLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateEdit="onEdit"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				isExport
				is-create
				is-settings
				:externalRefreshKey="externalRefreshKey"
				:externalResetKey="externalResetKey"
				:externalResetMode="externalResetMode"
		></main-table-all-back>

		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('employees')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
		></remove-block>

		<employees-form
				v-if="isEmployeesForm"
				:employeeId="employeeId"
				:permissions="permissions"
				@updateClose="onCloseDialog"
		></employees-form>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import EmployeesForm from "@/components/Maintenance/EmployeesForm/EmployeesForm.vue";
// shared
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
// constants
import { PERMISSIONS, PAGE } from "@/constants/constants";
import getUniqId from "@/helper/getUniqId";

export default {
	name: "Employees",
	mixins: [ settingsMixins, removeMixins ],
	components: { MainTableAllBack, EmployeesForm },
	computed: mapGetters([
		"employeesList",
		"employeesFilters",
		"employeesTotals",
		"permissions",
		"role",
		"employeesOrder",
		"employeesLimit",
		"employeesSort",
		"employeesTotal",
		"previewLink",
		"company_id",
	]),
	data: () => ({
		flag: PAGE.EMPLOYEES,
		isEmployeesForm: false,
		defaultFilter: {
			filter_active: [ 1 ],
		},
		activeTableFilters: null,
		employeeId: null,

		externalRefreshKey: null, // Обновление списка с фильтрами
		externalResetKey: null, // Сброс фильтров
		externalResetMode: 'default', // Тип сброса фильтров ('default' сброс до дефолтніх фильтров) | ('empty' спрос всех фильтров)
	}),
	methods: {
		...mapActions([
			'getEmployees',
			'getEmployeesFilters',
			'actionPreloader',
			'onExportLink',
			'onEmployeesRemoveItem',
			'getCompanyId'
		]),
		onCloseDialog(isRefresh) {
			this.isEmployeesForm = false;
			if (isRefresh) {
				this.externalRefresh;
			}
		},
		async onRemoveItem() {
			const { status } = await this.onEmployeesRemoveItem(this.removeId);
			if (status) this.isRemove = false;
			this.externalRefresh;
		},
		async onEvent(flag) {
			if (flag === 'create') {
				this.isEmployeesForm = true;
				this.employeeId = null;
			}
		},
		async onUpdateFilters(filters = {}, isWithoutFilters) {
			if (!filters || typeof filters !== 'object') {
				filters = {};
			}
			if ([ 22, 27, 43, 47 ].includes(Number(this.role))) {
				const companyFilter = filters.filter_company;

				if (
					!('filter_company' in filters) ||
						(Array.isArray(companyFilter) && companyFilter.length === 0)
				) {
					filters.filter_company = [ this.company_id ];
				}
			}
			await this.getEmployees(filters);
			if (!isWithoutFilters) await this.getEmployeesFilters(filters);
		},

		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getEmployees(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},

		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'employees' });
		},
		async onClickButton({ key, item }) {
			if (key === 'edit') {
				if (this.permissions[PERMISSIONS.EDIT]) {
					this.employeeId = item.employee_id;
					this.isEmployeesForm = true;
				} 
			}

			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.employee_id);
				}
			}
		},
		onEdit({ line }) {
			if (this.permissions[PERMISSIONS.EDIT]) {
				this.employeeId = line.employee_id;
				this.isEmployeesForm = true;
			}
		},
		externalRefresh() {
			// обновить таблицу, сохранив текущие фильтры
			this.externalRefreshKey = getUniqId();
		},
		externalReset(mode) {
			// 'default' | 'empty' (default до дефолтних | empty усі фільтра)
			this.externalResetMode = mode;
			this.externalResetKey = getUniqId();
		},

	},
	async mounted() {
		await this.getCompanyId();
		// await this.onUpdateFilters();
		await this.onUpdateFilters(this.defaultFilter);
	}
};
</script>
